import { SECTION } from '../../../../../shared/navigation/sections'

// The fleet-wide provider pages -- domains, health, findings, credential
// notifications, jobs, connect -- live at paths that are SIBLINGS of the
// provider list (/admin/sso/jobs next to /admin/sso/connections) rather
// than descendants of it. Breadcrumb nesting otherwise falls out of React
// Router v5's non-exact matching, which only mounts an ancestor crumb for a
// descendant path, so each of these showed a bare one-item trail ("JOBS")
// despite only being reachable through the provider section's own menu.
//
// Handing them the section entry explicitly is what BreadcrumbView's `parent`
// is for. The url is the list page, so the first crumb navigates back to
// exactly where the user came from.
//
// The section's crumb is the sidebar's own entry: its name and its plug icon
// (shared/navigation/sections.js, which the sidebar draws from), never the
// key the role pages use. The list page itself (provider-list.js) registers
// this same entry.
export const PROVIDER_SECTION_BREADCRUMB = SECTION.ssoConnections
